export default __webpack_public_path__ + "static/media/print.cbcc4ed1.svg";